const scrollboxs = document.querySelectorAll('.js-horizontal-scrollbox');

scrollboxs.forEach(scrollbox => new SimpleBar(scrollbox));